import {InfoCircleFilled} from '@ant-design/icons';
import React from 'react';
import './style.css';
const CustomizedTable = ({eventType, usedForBio, TableData}) => {
  const html = {__html: TableData};
  return <div dangerouslySetInnerHTML={html}></div>;
};

export default CustomizedTable;
